import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getI18nTextForFeaturesHeader = ({
  productLevel
}) => {
  switch (productLevel) {
    case 'FREE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.includes"
      });
    case 'STARTER':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.starter.includes"
      });
    case 'PROFESSIONAL':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.professional.lowerTierPlus"
      });
    case 'ENTERPRISE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.enterprise.lowerTierPlus"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.includes"
      });
  }
};
export const getI18nTextForFeatureItem = (level, skuCategoryName) => {
  if (level === 'FREE') {
    switch (skuCategoryName) {
      case 'MARKETING_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.marketing"
        });
      case 'SALES_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.sales"
        });
      case 'SERVICE_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.service"
        });
      case 'CMS_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.cms"
        });
      case 'OPERATIONS_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.operations"
        });
      case 'COMMERCE_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.commerce"
        });
      default:
        return null;
    }
  }
  if (level === 'STARTER') {
    switch (skuCategoryName) {
      case 'MARKETING_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.starter.marketing"
        });
      case 'SALES_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.starter.sales"
        });
      case 'SERVICE_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.starter.service"
        });
      case 'CMS_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.starter.cms"
        });
      case 'OPERATIONS_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.starter.operations"
        });
      case 'COMMERCE_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.starter.commerce"
        });
      default:
        return null;
    }
  }
  if (level === 'PROFESSIONAL') {
    switch (skuCategoryName) {
      case 'MARKETING_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.professional.marketing"
        });
      case 'SALES_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.professional.sales"
        });
      case 'SERVICE_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.professional.service"
        });
      case 'CMS_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.professional.cms"
        });
      case 'OPERATIONS_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.professional.operations"
        });
      case 'COMMERCE_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.professional.commerce"
        });
      default:
        return null;
    }
  }
  if (level === 'ENTERPRISE') {
    switch (skuCategoryName) {
      case 'MARKETING_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.enterprise.marketing"
        });
      case 'SALES_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.enterprise.sales"
        });
      case 'SERVICE_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.enterprise.service"
        });
      case 'CMS_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.enterprise.cms"
        });
      case 'OPERATIONS_HUB_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.enterprise.operations"
        });
      case 'COMMERCE_PRODUCTS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.enterprise.commerce"
        });
      default:
        return null;
    }
  }
  return null;
};